import { useState } from "react";
import { ReactComponent as AngleTopOutline } from "../../iconColor/angle-top-outline.svg";
import { ReactComponent as Ellipse } from "../../iconColor/Ellipse 6.svg";
import { motion } from "framer-motion";

const NotifAccordionComponent = ({
  mainNote,
  notificationsMessages,
  isOpenForce,
}: any) => {
  const [isOpen, setIsOpen] = useState(isOpenForce ?? true);

  function toggleHandeller() {
    setIsOpen(!isOpen);
  }

  return (
    <div className="flex flex-col justify-start w-full overflow-hidden flex-shrink-0 rounded-2xl bg-primary-50 pt-5 pb-5 pr-7 pl-7">
      <div
        onClick={toggleHandeller}
        className="flex w-full justify-between items-center cursor-pointer"
      >
        <h1 className="text-primary-800 text-justify text-BodyText/16/Medium">
          {mainNote}
        </h1>
        <motion.div
          animate={{ rotate: isOpen ? 0 : 180 }}
          transition={{ duration: 0.5 }}
        >
          <AngleTopOutline />
        </motion.div>
      </div>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{
          height: isOpen ? "auto" : 0.2,
          opacity: isOpen ? 1 : 0,
          transition: { duration: 0.7 },
        }}
        transition={{ duration: isOpen ? 0.5 : 0.7 }}
        className="overflow-hidden"
      >
        <div className="flex flex-col gap-3 mt-5">
          {notificationsMessages?.map(
            (notificationsMessage: any, index: any) => (
              <div key={index} className="flex gap-2 items-center">
                <div>
                  <div className="flex items-center gap-2">
                    <Ellipse />
                    <h1 className="text-gray-900 text-right text-BodyText/14/Regular">
                      {notificationsMessage.message}
                    </h1>
                  </div>
                  <p
                    className={`${
                      notificationsMessage.subTitle !== undefined
                        ? ""
                        : "hidden"
                    }`}
                  >
                    <div className="w-full flex flex-col ">
                      {" "}
                      {notificationsMessage.subTitle?.map(
                        (subTitle: any, idx: any) => (
                          <div className=" flex gap-2">
                            <p className="text-BodyText/14/Regular text-primary-600">
                              {subTitle.id}-
                            </p>
                            <p className="text-BodyText/14/Regular text-gray-900 ">
                              {subTitle.message}
                            </p>
                          </div>
                        )
                      )}
                    </div>
                  </p>
                </div>
              </div>
            )
          )}
        </div>
      </motion.div>
    </div>
  );
};
export default NotifAccordionComponent;
